var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xs-center pb-5 sz-kath-title"},[_vm._v("Kirchgemeinden")]),_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }